export const SUMMARY_SECTIONS = (URL) => {
  return [
    { label: 'Lead Response Rate',
      message: 'Your Lead Response Rate over 90 days:',
      formulaMessage: `<span>Your current</span><span class="text-bold"> Lead Response Rate</span><span> is your ([Contacted leads] + [Passed leads]) / [New leads] over the last 90 days. Lead Response Rate is one of the <a href="${URL}/prohelpcenter/s/article/Understanding-lead-volume?login=true" target="_blank">key performance metrics</a> that impacts the number of new leads that you recieve from Pro Referral.</span>`,
      eventName: 'PERFORMANCE_RESPONSE_CLICK',
      tabName: 'Response Tab',
    },
    { label: 'Lead Acceptance Rate',
      message: 'Your Lead Acceptance Rate over 90 days:',
      formulaMessage: `<span>Your current</span><span class="text-bold"> Lead Acceptance Rate</span><span> is your [Contacted leads] / [New leads] over the last 90 days. Contact Rate is one of the <a href="${URL}/prohelpcenter/s/article/Understanding-lead-volume?login=true" target="_blank">key performance metrics</a> that impacts the number of new leads that you recieve from Pro Referral.</span>`,
      eventName: 'PERFORMANCE_ACCEPTANCE_CLICK',
      tabName: 'Acceptance Tab',
    },
    { label: 'Completed Jobs',
      message: 'Total Completed Jobs over 90 Days:',
      formulaMessage: `Customers have higher confidence in Pros who have more reviews than Pros with fewer reviews. Be sure to <a href=${URL}/prohelpcenter/s/article/Updating-job-statuses?login=true target="_blank">update the status of your job</a> to <span class="text-bold">Complete</span> once you’ve finished the job to collect your reviews faster.`,
      eventName: 'PERFORMANCE_COMPLETED_CLICK',
      tabName: 'Completed Tab',
    },
  ];
};

export const CHART_OPTIONS = {

  leads (barColors, barData, offsets, showMinimumLine = false) {
    const options = {
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
      },
      dataLabels: {
        enabled: true,
        distributed: true,
        offsetY: offsets[0],
        formatter: ((_, opts) => {
          const newOpts = opts;
          const val = barData.data[opts.dataPointIndex];
          newOpts.w.config.dataLabels.offsetY = offsets[opts.dataPointIndex + 1] || offsets[0];
          return `${val}%`;
        }),
        style: {
          postion: 'top',
          fontSize: '14px',
          colors: ['#333333'],
        },
      },
      stroke: {
        show: false,
      },
      fill: {
        colors: barColors,
        opacity: 1,
        type: 'solid',
      },
      legend: { show: false },
      tooltip: { enabled: false },
      chart: {
        brush: {
          autoScaleYaxis: false,
        },
        animations: {
          enabled: false,
        },
        id: 'summary',
        type: 'bar',
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          columnWidth: '70%',
          distributed: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      grid: {
        show: true,
        postion: 'back',
        padding: {
          top: -30,
          right: 0,
          bottom: 0,
          left: 32,
        },
      },
      xaxis: {
        categories: ['Last 90 Days', 'Last 60 Days', 'Last 30 Days'],
        position: 'bottom',
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        labels: {
          style: {
            fontWeight: 400,
            colors: ['#333333'],
          },
          show: true,
          rotate: 0,
          offsetX: 0,
        },
      },
      yaxis: {
        tickAmount: 5,
        axisBorder: {
          show: false,
        },
        min: 0,
        max: 100,
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
    };

    options.annotations = showMinimumLine
      ? {
        yaxis: [{
          y: 20,
          borderColor: '#D22630',
          strokeDashArray: 4,
          label: {
            offsetX: 30,
            borderColor: 'transparent',
            text: 'Minimum 20%',
            position: 'left',
            style: {
              background: 'transparent',
              color: '#D22630',
              fontSize: '9px',
              fontWeight: 600,
            },
          },
        }],
      }
      : { yaxis: [] };

    return options;
  },

  completed (barColors, weeksCompletedJobs, jobsCompletedPerWeek) {
    const maxChart = jobsCompletedPerWeek[0].data.reduce((a, b) => {
      return Math.max(a, b || 1);
    });
    const completedJobsCategories = weeksCompletedJobs.map(item => item);
    completedJobsCategories.splice(-1, 1, 'Today');

    return {
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        formatter: ((val) => {
          if (val >= 0) {
            return val === 1 ? `${val} job` : `${val} jobs`;
          }
        }),
        style: {
          postion: 'top',
          fontSize: '14px',
          fontWeight: 400,
          colors: ['#333333'],
        },
      },
      stroke: {
        show: true,
        colors: barColors,
        width: 4,
      },
      fill: {
        colors: barColors,
        opacity: 1,
        type: 'solid',
      },
      legend: { show: false },
      tooltip: { enabled: false },
      chart: {
        id: 'summary',
        type: 'bar',
        toolbar: { show: false },
        animations: {
          enabled: false,
        },
      },
      plotOptions: {
        bar: {
          border: {
            show: false,
          },
          distributed: true,
          columnWidth: '95%',
          forceNiceScale: true,
        },
      },
      grid: {
        show: true,
        postion: 'back',
        padding: {
          top: -10,
          right: 0,
          bottom: 0,
          left: 32,
        },
      },
      xaxis: {
        lines: {
          colors: ['red', 'black'],
        },
        type: 'category',
        tickPlacement: 'between',
        position: 'bottom',
        categories: completedJobsCategories,
        labels: {
          style: {
            fontWeight: 400,
            colors: ['#333333'],
          },
          show: true,
          rotate: 0,
          offsetX: -8,
        },
        axisBorder: {
          show: false,
        },

        axisTicks: {
          show: true,
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        tickAmount: 5,
        axisBorder: {
          show: false,
        },
        min: 0,
        max: maxChart * 1.1,
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
    };
  },
};
